import { AvatarProps, AvatarIconProps, AvatarLabelProps, AvatarPortraitProps, BaseAvatarProps } from '@procore/core-react/dist/_typedoc/Avatar/Avatar.types.json';
import * as React from 'react';
export default {
  AvatarProps,
  AvatarIconProps,
  AvatarLabelProps,
  AvatarPortraitProps,
  BaseAvatarProps,
  React
};